import React, { useEffect, useState } from 'react';

import PackageVariantClosedIcon from 'mdi-react/PackageVariantClosedIcon';

import ItemNavLink from 'domain/fuse/preferences/DynamicNavLink/ItemNavLink';
import AssignSidebar from 'domain/shipment/assign/sidebar';

const Sidebar = (props) => {
  const {
    isAllowedMenuItem,

    authorities,

    classes,

    toggleDrawer,

    currentPageTitle,

    setCurrentPageTitle,

    isSidebarItemActive,

    titleMapping,

    open,
  } = props;

  const [isAllowed, setAllowed] = useState(false);

  useEffect(() => {
    setAllowed(isAllowedMenuItem('SHIPMENTS', authorities));
  }, [authorities]);

  return (
    <>
      {isAllowed && (
        <>
          <ItemNavLink
            classes={classes}
            titleMapping={titleMapping}
            toggleDrawer={toggleDrawer}
            isSidebarItemActive={isSidebarItemActive}
            open={open}
            toUrl="/shipments"
            itemKey="salesOrder"
            iconComponent={<PackageVariantClosedIcon />}
            groupTitle="shipping"
          />

          <ItemNavLink
            classes={classes}
            titleMapping={titleMapping}
            toggleDrawer={toggleDrawer}
            isSidebarItemActive={isSidebarItemActive}
            open={open}
            toUrl="/waybills"
            itemKey="waybills"
            iconComponent={<PackageVariantClosedIcon />}
            groupTitle="shipping"
          />

          <AssignSidebar {...props} />
        </>
      )}
    </>
  );
};

export default Sidebar;
